var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
a:{var Ba=$CLJS.ea.navigator;if(Ba){var Da=Ba.userAgent;if(Da){$CLJS.Aa=Da;break a}}$CLJS.Aa=""};